import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IChipProps = {
  line: string
}

export const Chip = ({ line }: IChipProps) => {
  return (
    <div className={styles.chip}>
      <Typography
        ariaLabel='ModalInfoBlockWithTitle'
        variant='body-xs-medium'
        color='var(--gray-80)'
      >
        {line}
      </Typography>
    </div>
  )
}
